import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss'],
})
export class PageNotFoundComponent implements OnInit {
  constructor(private router: Router) {}

  protected readonly multiplyNum = 3;
  protected readonly siteSizeWidth = `${116 * this.multiplyNum}`;
  protected readonly siteSizeH5Width = `${116 * this.multiplyNum}`;
  protected readonly logoHeight = `${24 * this.multiplyNum}`;

  ngOnInit() {}

  goHome() {
    this.router.navigate(['']);
  }
}
